import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import {
  IllustrationComingSoon,
  IllustrationEmptyList,
  IllustrationNoSearchResults,
} from './Illustration';

export type EmptyStateVariant = 'list' | 'search' | 'soon';

export interface EmptyStateProps {
  icon?: ReactNode;
  variant?: EmptyStateVariant;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

const ILLUSTRATIONS: Record<EmptyStateVariant, React.ComponentType<{ className?: string }>> = {
  list: IllustrationEmptyList,
  search: IllustrationNoSearchResults,
  soon: IllustrationComingSoon,
};

export function EmptyState({
  icon,
  variant,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  const Illustration = variant ? ILLUSTRATIONS[variant] : null;
  return (
    <div
      className={cn('flex flex-col items-center justify-center px-4 py-12 text-center', className)}
    >
      {Illustration ? (
        <Illustration className="mb-5" />
      ) : icon ? (
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 text-text-muted">
          {icon}
        </div>
      ) : null}
      <p className="text-base font-medium text-brand">{title}</p>
      {description && <p className="mt-1 max-w-sm text-sm text-text-muted">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
